import { Component, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { IMetaData } from "src/app/interfaces";

@Component({
    selector: "circ-metadata-string",
    templateUrl: "./string.component.html",
    styleUrls: ["./string.component.scss"],
    standalone: false
})
export class StringComponent {
  @Input()
  @Output()
  public data: IMetaData;

  @Input()
  public formGroup: FormGroup;
}
